import { css, styled } from "@mui/material";

export const StatsGrid = styled("div")(
  ({ theme }) => css`
    display: grid;
    justify-items: center;
    gap: 1rem;

    ${theme.breakpoints.up("mobile")} {
      grid-template-columns: repeat(2, 1fr);
    }

    ${theme.breakpoints.up("tablet")} {
      grid-template-columns: repeat(4, 1fr);
    }

    ${theme.breakpoints.up("desktop")} {
      grid-template-columns: repeat(4, 1fr);
    }
  `,
);
